import { render } from "./FullScreenImageViewer.vue?vue&type=template&id=1357a0bc&scoped=true"
import script from "./FullScreenImageViewer.vue?vue&type=script&lang=js"
export * from "./FullScreenImageViewer.vue?vue&type=script&lang=js"

import "./FullScreenImageViewer.vue?vue&type=style&index=0&id=1357a0bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1357a0bc"]])

export default __exports__